export const USER_TYPE_DATA = 'data';